module.exports = __webpack_public_path__ + "img/doorLogo5.9ee0abe4.png";